import { LimitOrderCreator } from "./limitOrderCreator";

export class IOCOrderCreator extends LimitOrderCreator {}
